import script from "./operationManage.vue?vue&type=script&setup=true&lang=js"
export * from "./operationManage.vue?vue&type=script&setup=true&lang=js"

import "./operationManage.vue?vue&type=style&index=0&id=2937d900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2937d900"]])

export default __exports__